export default "__VITE_ASSET__QyYks5EO__"